import { AnalyticsServiceFactory } from '@rci/analytics-service';
import { AudienceManagerService } from '@rci/audience-manager-service';
import { EnvironmentConfig, EnvironmentConfigurator } from '@rci/environment-loader';
import { MiscService } from '@rci/misc-service';
import { RoutingService } from '@rci/routing-service';
import { StateService } from '@rci/state-service';

import { SelfServeAppInitializerService } from './lib/service/app-initializer/self-serve-app-initializer.service';
import { SemafoneConfigService } from './lib/service/semafone-config/semafone-config.service';
import { SemafoneConfig } from './lib/service/semafone-config/semafone-config.model';

export const environmentConfigurator: EnvironmentConfigurator<EnvironmentConfig | any> = env => [
  {
    class: AudienceManagerService,
    config: {
      segments: env.segments,
      audienceManagerUrlTemplate: env.audienceManagerUrlTemplate,
    },
  },
  {
    class: MiscService,
    config: {
      loaderFadeOutDelay: env.loaderFadeOutDelay,
    },
  },
  {
    class: RoutingService,
    config: {
      domain: env.domain,
    },
  },
  {
    class: StateService,
    config: {
      domain: env.domain,
      cookieDomain: env.cookieDomain,
    },
  },
  {
    class: AnalyticsServiceFactory,
    config: {
      siteName: env.analytics.site.name,
    },
  },
  {
    class: SelfServeAppInitializerService,
    config: {
      externalScripts: env.externalScripts,
    },
  },
  {
    class: SemafoneConfigService,
    config: {
      ...env.semafoneMonerisConsumerConfig,
    } as SemafoneConfig,
  },
];
